import { ricsterTerms } from '../docs/ricster/terms'
import { ricsterPrivacy } from '../docs/ricster/privacy'
import { InfoPageContainer } from '../components/InfoPageContainer'
import { flowsterTerms } from '../docs/flowster/terms'
import { flowsterPrivacy } from '../docs/flowster/privacy'

interface InfoItem {
  title: string
  contents: { header: string; body: string[] }[]
  effectiveDate: string
}

interface Props {
  name: string
}

export function InfoPage({ name }: Props) {
  function page(name: string) {
    const lookup: Record<string, InfoItem> = {
      'ricster/terms-of-service': {
        title: 'Terms of Service',
        contents: ricsterTerms.contents,
        effectiveDate: ricsterTerms.effectiveDate,
      },
      'ricster/privacy-policy': {
        title: 'Privacy Policy',
        contents: ricsterPrivacy.contents,
        effectiveDate: ricsterPrivacy.effectiveDate,
      },
      'flowster/terms-of-service': {
        title: 'Terms of Service',
        contents: flowsterTerms.contents,
        effectiveDate: flowsterTerms.effectiveDate,
      },
      'flowster/privacy-policy': {
        title: 'Privacy Policy',
        contents: flowsterPrivacy.contents,
        effectiveDate: flowsterPrivacy.effectiveDate,
      },
    }

    const item = lookup[name]

    return (
      <InfoPageContainer
        title={String(item.title)}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        contents={item.contents as any}
        effectiveDate={item.effectiveDate}
      />
    )
  }

  return page(name)
}
